<template>
  <v-card>
    <v-toolbar flat>
      <v-icon>person</v-icon>
      <v-toolbar-title>{{ $t('auth.login') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container class="credentials-container">
        <v-form ref="credentials-form" v-model="validLoginForm" @submit.prevent="submitCredentials">
          <v-card elevation="10">
            <v-card-text>
              <v-text-field id="username" v-model="username" :disabled="this.$store.state.loading"
                            :rules="isRequired" class="dark-theme-autofill"
                            clearable label="Username" name="username" required type="text"/>
              <v-text-field id="password" v-model="password" :disabled="this.$store.state.loading"
                            :rules="isRequired" class="dark-theme-autofill"
                            clearable label="Password" name="password" required type="password"/>
            </v-card-text>
            <v-card-actions>
              <v-btn :disabled="!this.validLoginForm" :loading="this.$store.state.loading"
                     color="primary" type="submit">Login
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import {i18n} from "@/main";

export default {
  data() {
    return {
      password: "",
      username: "",
      validLoginForm: false,
      alert: false,
      isRequired: [
        value => {
          if (value) {
            return true;
          }

          return i18n.tc('global.rules.required');
        }
      ]
    };
  },
  mounted() {
    if (this.error) {
      this.alert = true;
    }
  },
  beforeDestroy() {
    this.$store.commit('setError', null);
  },
  computed: {
    error() {
      return this.$store.state.error;
    }
  },
  watch: {
    error(value) {
      this.alert = !!value;
    },
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    },
  },
  methods: {
    submitCredentials() {
      if (!this.validLoginForm) {
        return;
      }
      this.$store.dispatch("submitCredentials", {
        password: this.password,
        username: this.username,
      });
      this.resetValidationCredentialsForm();
    },
    resetValidationCredentialsForm() {
      this.$refs["credentials-form"].resetValidation();
    }
  },
};
</script>

<style scoped>
#app .main-content {
  max-width: 800px;
}

.credentials-container {
  width: 350px;
}

.credentials-container .v-btn {
  display: block;
  margin: 6px auto;
}

.dark-theme-autofill {
  input, select {
    color: #fff;
    -webkit-text-fill-color: white;
    -webkit-background-clip: text !important;
    background-clip: text !important;
  }
}
</style>
